import type { CSSProperties, ElementType, ReactNode } from "react";

/**
 * A headline whose lines slide up from behind a mask as it scrolls in.
 * Driven by RevealRoot (`data-reveal-lines`), so it is plain CSS and the
 * prerendered page shows the finished headline.
 */
type LinesProps = {
  lines: ReactNode[];
  as?: ElementType;
  className?: string;
  /** Per-line class, e.g. to outline every second line. */
  lineClassName?: (index: number) => string;
  delay?: number;
};

const Lines = ({ lines, as: Tag = "h2", className = "", lineClassName, delay = 0 }: LinesProps) => (
  <Tag
    className={className}
    data-reveal-lines
    style={{ "--reveal-delay": `${delay}ms` } as CSSProperties}
  >
    {lines.map((line, i) => (
      <span key={i} className="line" style={{ "--line": i } as CSSProperties}>
        <span className={lineClassName?.(i) ?? ""}>{line}</span>
        {/* Keep the words apart for crawlers and screen readers, which read
            the block lines as one run of text. */}
        {i < lines.length - 1 ? " " : null}
      </span>
    ))}
  </Tag>
);

export default Lines;
